export enum IdentityProvider {
  CRZP = 'CRZP',
  JIP_KAAS = 'JIP_KAAS',
  NIA = 'NIA',
  MOJE_ID = 'MOJE_ID',
  CAAIS = 'CAAIS',
}
